import script from "./TopMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopMain.vue?vue&type=script&lang=ts&setup=true"

import "./TopMain.vue?vue&type=style&index=0&id=7196921b&scoped=true&lang=css"

import exportComponent from "E:\\code\\my\\bookmark.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7196921b"]])

export default __exports__